import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { MenuSectionType } from 'types/graphql';
import { EDITABLE_HOMEPAGE_CAROUSEL_HEADINGS_FLAG } from 'shared/constants';
import { PREBUILT_CAROUSEL_SECTIONS } from '../homepage-form.constants';
import { LocalSection, Products } from '../homepage-form.types';
import { AddCategoryModal } from './add-category-modal';
import { BrandModal } from './brand-modal';
import { CustomModal } from './custom-modal';
import { AddCollectionModal } from './add-collection-modal';
import AddImageSection from './add-image-section';
import { HeadingOverrideModal } from './heading-override-modal';

export type ModalControllerProps = {
  handleAddSection: (newSection: LocalSection) => void;
  menuSection: LocalSection | null;
  menuSections: LocalSection[] | null;
  onToggle: () => void;
  products: Products | null;
  sectionTypeKey: MenuSectionType;
};

const sectionTypeToModal: Record<MenuSectionType, React.FC<ModalControllerProps> | null> = {
  [MenuSectionType.brand]: BrandModal,
  [MenuSectionType.category]: AddCategoryModal,
  [MenuSectionType.collection]: AddCollectionModal,
  [MenuSectionType.custom]: CustomModal,
  [MenuSectionType.image]: AddImageSection,
  [MenuSectionType.offers]: null,
  [MenuSectionType.recentlyViewed]: null,
  [MenuSectionType.recommendedForYou]: null,
  [MenuSectionType.specials]: null,
  [MenuSectionType.staffPicks]: null,
  [MenuSectionType.subcategory]: AddCategoryModal,
  [MenuSectionType.topSellers]: null,
};

export function ModalController(props: ModalControllerProps): JSX.Element | null {
  const { handleAddSection, menuSection, onToggle, sectionTypeKey } = props;
  const flags = useFlags();
  const editableHeadingsEnabled = flags[EDITABLE_HOMEPAGE_CAROUSEL_HEADINGS_FLAG] ?? false;

  if (editableHeadingsEnabled && menuSection && PREBUILT_CAROUSEL_SECTIONS.includes(sectionTypeKey)) {
    return <HeadingOverrideModal handleAddSection={handleAddSection} menuSection={menuSection} onToggle={onToggle} />;
  }

  const Modal = sectionTypeToModal[sectionTypeKey];

  if (!Modal) {
    return null;
  }

  return <Modal {...props} />;
}
